export default function getWeekDay(daysToSkip = 0) {
  const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  const day = new Date();
  day.setDate(day.getDate() + daysToSkip);

  return weekDays[day.getDay()];
}
